<!-- One viewBox for every drawing so they occupy identical space and the panel
     does not reflow when a screen swaps art. `currentColor` throughout; the
     host sets white. Solid discs use --dv-navy so a glyph drawn ON them reads. -->
<svg viewBox="0 0 520 420" fill="none" stroke-linecap="round" stroke-linejoin="round"
     role="img" [attr.aria-label]="null" aria-hidden="true">

  <!-- Shared ground: the storefront every drawing is built on. -->
  <ellipse cx="260" cy="372" rx="196" ry="18" fill="currentColor" opacity=".10" />
  <circle class="art__halo" cx="262" cy="200" r="150" fill="currentColor" opacity=".07" />

  <g stroke="currentColor" stroke-width="5" opacity=".92">
    <path d="M126 182h268v164H126z" />
    <path d="M110 182l26-52h248l26 52" />
    <path d="M126 218h268" />
    <path d="M176 346V262h72v84" />
  </g>
  <g stroke="currentColor" stroke-width="3.5" opacity=".45">
    <path d="M150 130l-8 52M198 130l-4 52M246 130v52M294 130l4 52M342 130l8 52" />
  </g>
  <g stroke="currentColor" stroke-width="5" opacity=".92">
    <path d="M286 264h52v48h-52z" /><path d="M286 288h52" /><path d="M312 264v48" />
  </g>
  <g stroke="currentColor" stroke-width="4" opacity=".32">
    <path d="M74 250h26M58 282h42M82 314h18" />
  </g>

  <!-- The badge: one disc, a different glyph per screen. Keeping the disc
       shared is what makes the five drawings read as one family. -->
  <circle cx="386" cy="300" r="70" fill="var(--dv-navy)" />
  <circle cx="386" cy="300" r="70" stroke="currentColor" stroke-width="5" />

  @switch (name()) {
    @case ("locked") {
      <!-- Closed padlock: signed in, role missing. -->
      <g stroke="currentColor" stroke-width="5">
        <path d="M366 272v-12a20 20 0 0 1 40 0v12" />
        <rect x="354" y="272" width="64" height="50" rx="9" />
        <path d="M386 298v10" />
      </g>
      <circle cx="386" cy="292" r="6.5" fill="currentColor" />
    }
    @case ("door") {
      <!-- Open door with a threshold arrow: come in. -->
      <g stroke="currentColor" stroke-width="5">
        <path d="M368 266h38v68h-38z" />
        <path d="M368 266l-18 8v54l18 6" />
        <path d="M344 300h-24" /><path d="M330 290l-10 10 10 10" />
      </g>
    }
    @case ("wrong-key") {
      <!-- A key that does not fit: right person, wrong organization. -->
      <g class="art__key" stroke="currentColor" stroke-width="5">
        <circle cx="366" cy="284" r="15" />
        <path d="M376 295l28 28" /><path d="M396 315l-9 9" /><path d="M404 323l-8 8" />
      </g>
      <g class="art__miss" stroke="currentColor" stroke-width="5" opacity=".55">
        <path d="M410 272l18 18M428 272l-18 18" />
      </g>
    }
    @case ("expired") {
      <!-- Clock past the hour: the session timed out. -->
      <g stroke="currentColor" stroke-width="5">
        <circle cx="386" cy="300" r="34" />
        <path d="M386 280v22l15 10" />
      </g>
    }
    @case ("unknown") {
      <!-- Map pin with a query: no organization at this address. -->
      <g stroke="currentColor" stroke-width="5">
        <path d="M386 268a24 24 0 0 1 24 24c0 17-24 42-24 42s-24-25-24-42a24 24 0 0 1 24-24z" />
      </g>
      <circle cx="386" cy="292" r="8" fill="currentColor" />
    }
  }
</svg>
